import isUndefined from 'lodash/isUndefined'
import omitBy from 'lodash/omitBy'
import React from 'react'

import Button, { ButtonV2 } from '~/components/button'
import trackingUtils from '~/utils/enhanced-commerce-tracking'

import type { TrackedEventInfo } from './types'
import type { MouseEvent } from 'react'
import type { Props as ButtonProps } from '~/components/button'

type Props = ButtonProps &
  TrackedEventInfo & {
    ButtonComponent?: typeof Button | typeof ButtonV2
  }

export default function TrackedButton({
  children,
  onClick,
  eventCategory,
  eventType = 'other',
  eventName,
  eventDestination,
  ButtonComponent = Button,
  eventPosition,
  ...restProps
}: Props) {
  const onClickWithTracking = (event: MouseEvent) => {
    const eventInfoOptionalParams = {
      type: eventType,
      position: eventPosition,
    }
    const eventInfo = {
      category: eventCategory,
      destination: eventDestination,
      name: eventName,
      ...omitBy(eventInfoOptionalParams, isUndefined),
    }

    trackingUtils.link(eventInfo)

    if (onClick) onClick(event)
  }

  return (
    <ButtonComponent onClick={onClickWithTracking} {...restProps}>
      {children}
    </ButtonComponent>
  )
}
